module.exports = __webpack_public_path__ + "static/media/pin.5e1001fa.svg";